const MenuData = [
    {
        iconClass: 'menu-home-icon',
        id: '1',
        parentId: '0',
        route: {name: 'userHomePage'},
        title: '主页',
        isOther: true, // 他人视角是否显示
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-dashboard-icon',
        id: '22',
        parentId: '0',
        route: { name: 'dashboard' },
        title: '我的数据看板',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-app-icon',
        id: '2',
        parentId: '0',
        title: '我的应用',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-buddy-icon',
        id: '30',
        parentId: '0',
        route: { path: '/buddy/home' },
        title: '我的学伴',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-archive-icon',
        id: '20',
        parentId: '0',
        route: { name: 'achievement' },
        title: '我的成果',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-collect-icon',
        id: '21',
        parentId: '0',
        route: { name: 'myCollect' },
        title: '我的收藏',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-fllow-icon',
        id: '3',
        parentId: '0',
        route: { name: 'followList' },
        title: '关注',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-buddy-icon',
        id: '6',
        parentId: '0',
        route: { path: '/buddy/multi/home' },
        title: 'AI成长伙伴',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-accout-icon',
        id: '4',
        parentId: '0',
        title: '个人设置',
        isOther: false,
        hidden: false, // 是否隐藏
        children: [
            {
                id: '4-1',
                parentId: '4',
                route: { name: 'accountInfo' },
                title: '个人信息'
            },
            {
                id: '4-2',
                parentId: '4',
                route: { name: 'accountSecurity' },
                title: '账号安全'
            }
        ]
    },
    {
        iconClass: 'menu-message-icon',
        id: '5',
        parentId: '0',
        route: { name: 'myMessage' },
        title: '我的消息',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    {
        iconClass: 'menu-feedback-icon',
        id: '29',
        parentId: '0',
        route: { name: 'feedback' },
        title: '我的反馈',
        isOther: false,
        hidden: false, // 是否隐藏
    },
    
]
export default MenuData;
